import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import Dashboard from './pages/Dashboard';
import Jobs from './pages/Jobs';
import Job from './pages/Job';
import Machines from './pages/Machines';
import Deliveries from './pages/Deliveries';
import Notifications from './pages/Notifications';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Calendar from './pages/Calendar';
import Layout from './components/Layout';
import Parts from './pages/Parts';
import Part from './pages/Part';
import Customers from './pages/Customers';
import Financials from './pages/Financials';
import AccessDenied from './pages/AccessDenied';
import Production from './pages/Production';
import CNCQuote from './pages/CNCQuote';
import Kanban from './pages/Kanban';
import KanbanJob from './pages/KanbanJob';
import DeDupeKanban from './pages/DeDupeKanban';
import StandardPOs from './pages/StandardPOs';
import Invoices from './pages/Invoices';
import About from './pages/Website/About';
import Contact from './pages/Website/Contact';
import ManualQuote from './pages/ManualQuote';
import Vendors from './pages/Vendors';
import PurchaseOrders from './pages/PurchaseOrders';
import PurchaseOrder from './pages/PurchaseOrder';
import CustomerQuotes from './pages/CustomerQuotes';
import CustomerQuote from './pages/CustomerQuote';
import FreeformQuotes from './pages/FreeformQuotes';
import FreeformQuote from './pages/FreeformQuote';

// Dev: expose pricing-engine regression test on window for manual verification.
// Run `verifyQuotePricing()` in the browser console.
if (process.env.NODE_ENV === 'development') {
  import('./utils/quoteUtils').then((m) => {
    window.verifyQuotePricing = m.verifyPricingEngine;
  });
}

const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  { path: '/signup1213287', element: <SignUp /> },
  {
    element: <Layout />,
    children: [
      { path: '/dashboard', element: <Dashboard /> },
      { path: '/jobs', element: <Jobs /> },
      { path: '/jobs/:po_number', element: <Job /> },
      { path: '/customers', element: <Customers /> },
      { path: '/machines', element: <Machines /> },
      { path: '/deliveries', element: <Deliveries /> },
      { path: '/notifications', element: <Notifications /> },
      { path: '/reports', element: <Reports /> },
      { path: '/settings', element: <Settings /> },
      { path: '/calendar', element: <Calendar /> },
      { path: '/parts', element: <Parts /> },
      { path: '/financials', element: <Financials /> },
      { path: '/part/:part_number', element: <Part /> },
      { path: '/access-denied', element: <AccessDenied /> },
      { path: '/production', element: <Production /> },
      { path: '/cncquote', element: <CNCQuote /> },
      { path: '/kanban', element: <Kanban /> },
      { path: '/kanban/:id', element: <KanbanJob /> },
      { path: '/dedupe-kanban', element: <DeDupeKanban /> },
      { path: '/standard-pos', element: <StandardPOs /> },
      { path: '/invoices', element: <Invoices /> },
      { path: '/manualQuote', element: <ManualQuote /> },
      { path: '/vendors', element: <Vendors /> },
      { path: '/purchase-orders', element: <PurchaseOrders /> },
      { path: '/purchase-orders/:id', element: <PurchaseOrder /> },
      { path: '/customer-quotes', element: <CustomerQuotes /> },
      { path: '/customer-quotes/:id', element: <CustomerQuote /> },
      { path: '/freeform-quotes', element: <FreeformQuotes /> },
      { path: '/freeform-quotes/:id', element: <FreeformQuote /> },
    ],
  },
  { path: '/', element: <Login /> },
  { path: '/about', element: <About /> },
  { path: '/contact', element: <Contact /> },
]);

function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;
